import { useState, useSyncExternalStore } from "react";
import { Download } from "lucide-react";
import { getInstallPrompt, promptToInstall, subscribeInstallPrompt } from "../lib/installPrompt";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";

const isInstalled = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iPad|iPhone|iPod/.test(window.navigator.userAgent)
  || (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

// « Installer Jamora »: the browser's own install prompt when it offers one, else the manual steps. Renders nothing once installed.
// `className` styles the button (sidebar or page), the dialog is the same everywhere.
export default function InstallButton({ className, testid = "install-jamora" }) {
  const prompt = useSyncExternalStore(subscribeInstallPrompt, getInstallPrompt);
  const [help, setHelp] = useState(false);
  if (isInstalled()) return null;

  const install = async () => {
    if (prompt) {
      try {
        await promptToInstall();
        return;
      } catch {
        // The browser may withdraw its prompt; show the manual steps instead.
      }
    }
    setHelp(true);
  };

  return (
    <>
      <button type="button" onClick={install} data-testid={testid} className={className}>
        <Download size={18} aria-hidden="true" />
        Installer Jamora
      </button>
      <Dialog open={help} onOpenChange={setHelp}>
        <DialogContent className="max-w-sm rounded-lg">
          <DialogHeader>
            <DialogTitle>Installer Jamora</DialogTitle>
            <DialogDescription>
              {isIOS()
                ? "Dans Safari, touchez Partager, puis « Sur l’écran d’accueil » et « Ajouter ». Si l’option manque, ouvrez cette page dans Safari."
                : "Ouvrez le menu de votre navigateur, puis choisissez « Installer l’application » ou « Ajouter à l’écran d’accueil »."}
            </DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
    </>
  );
}
